<template>
  <a-tooltip title="Copiar">
    <a-button
      class="button"
      type="text"
      v-clipboard:copy="value"
      v-clipboard:success="handleCopySuccess"
      v-clipboard:error="handleCopyError"
      :disabled="disabled"
    >
      <CopyOutlined />
    </a-button>
  </a-tooltip>
</template>

<script setup lang="ts">
import { CopyOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";

defineProps<{ value: unknown; disabled?: boolean }>();

const handleCopyError = () => {
  message.error("No se pudo copiar");
};

const handleCopySuccess = () => {
  message.success("Copiado");
};
</script>

<style scoped lang="sass">
.button
  padding: 0
  height: 22px
</style>
